module.exports = __webpack_public_path__ + "img/dab_palacowy.aa920e62.jpg";